<app-item-box
  #itemBox
  class="item-box"
  [class.expandable-faq]="isExpandable"
  [class.hidden-faq]="isHidden"
  [class.published-page]="!isEditing"
  [hoverable]="true"
  [expandable]="isExpandable"
  [expanded]="isExpanded"
  [shadow]="!isHidden"
  (expandedChange)="faqHeaderClicked($event)">
  <ng-template #header>
    <ng-container *ngTemplateOutlet="faq ? faqRef : addFaqRef"></ng-container>
  </ng-template>

  <ng-template #body>
    @if (faq) {
      <app-formatted-text
        class="faq-answer font-main text-base text-navy-70 {{ isExpandable ? 'cursor-default' : 'cursor-pointer' }}"
        [text]="faq.answer">
      </app-formatted-text>
    }
  </ng-template>
</app-item-box>

<ng-template #faqRef>
  <div class="faq-question flex items-center w-full gap-x-3">
    <svg-icon class="faq-icon self-start w-8 h-8" [src]="'faq'"></svg-icon>

    <div class="flex-1">
      <span class="faq-question font-main text-3xl font-bold text-navy-90">{{ faq.question }}</span>

      @if (isEditing && isHidden) {
        <svg-icon class="eye-icon w-6 h-6 text-navy-90 ml-3 align-middle" [src]="'eye'"></svg-icon>
      }
    </div>

    @if (isEditing) {
      <app-icon-button
        class="edit-btn self-start"
        [svgIconPath]="'edit'"
        [type]="'basic'"
        [iconSize]="'small'"
        [size]="'tiny'">
      </app-icon-button>
    } @else {
      <svg-icon class="arrow-icon text-navy-90" [src]="itemBox.expanded ? 'arrow-up' : 'arrow-down'"></svg-icon>
    }
  </div>
</ng-template>

<ng-template #addFaqRef>
  <div class="add-faq-btn flex items-center w-full gap-x-6" role="button">
    <svg-icon class="w-10.5 h-10.5" [src]="'add-filled'"></svg-icon>

    <span class="flex-1 text-3xl font-bold text-navy-90">
      {{ buildTranslationKey('addFaq') | translate }}
    </span>
  </div>
</ng-template>
